// packages/hooks/useProducts.ts (ou dans ton app)
import { productService } from "@cabukaka/services";
import { Product, QueryFilters } from "@cabukaka/types";
import { useData } from "../core/useData";

export function useProducts( initialFilters?: QueryFilters) {
    // 1. On utilise le hook générique pour le gros du travail
    const { 
        data: products, 
        loading, 
        error, 
        refresh, 
        deleteItem, 
        updateItem ,
        deleteManyItems
    } = useData<Product>({
        ...productService,
        ...productService.baseService
    }, initialFilters);

  

    return {
        products,
        loading,
        error,
        refresh,
        deleteProduct: deleteItem,
        updateProduct: updateItem,
        deleteManyProducts: deleteManyItems
    };
}